import publicRuntimeConfig from "@FRAMEWORK/config/public";
import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import {Response} from "@QUERIES/types";
import {UseQueryOptions, useQuery} from "@tanstack/react-query";

interface ContentsEmergency {
	emerInfoCd: string;
	emerInfoNm: string;
	emerInfoTitle: string;
	emerInfoConts: string;
	commCdOrder: number;
}

/** ```
 * 긴급안내 상품코드 조회
 *   `/contents/goods-emergency/{goodsCd}`
 * parameter
 * 		goodsCd : 상품코드
 * ```*/
const key = "useContentsEmergency";
const getPath = (goodsCd: string): string | null =>
	`${publicRuntimeConfig.ENV_PORTAL_API_URL}/pkg/goods/goods-emergency/${goodsCd}`;

/** ```
 * 긴급안내 상품코드 조회 SSR
 *   `/contents/goods-emergency/{goodsCd}`
 * parameter
 * 		goodsCd : 상품코드
 * ```*/
const contentsEmergencySSR = (goodsCd: string) => useConfigureAxios(getPath(goodsCd));

/** ```
 * 긴급안내 상품코드 조회
 *   `/contents/goods-emergency/{goodsCd}`
 * parameter
 * 		goodsCd : 상품코드
 * ```*/
const useContentsEmergency = (
	goodsCd: string,
	options?: Partial<UseQueryOptions<Response<ContentsEmergency[]>, Error>>,
) =>
	useQuery({
		queryKey: [key, getPath(goodsCd)],
		queryFn: () => useConfigureAxios({url: getPath(goodsCd)}).then(r => r.data),
		gcTime: Infinity,
		staleTime: Infinity,
		...options,
	});

export default useContentsEmergency;
export {getPath, contentsEmergencySSR};
export type {ContentsEmergency};
